export default __webpack_public_path__ + "static/logo-main-black-5d5e3703348c4dc7835bdd8a09d29379.png";